var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#E3EFFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_5013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.87776 12.9802L4.92877 9.95001C4.91176 9.93253 4.89827 9.91176 4.88906 9.88887C4.87985 9.86599 4.87511 9.84145 4.87511 9.81666C4.87511 9.79188 4.87985 9.76734 4.88906 9.74445C4.89827 9.72157 4.91176 9.70079 4.92877 9.68332L5.67326 8.91316C5.7444 8.83965 5.85938 8.83965 5.93052 8.91316L7.87197 10.9074C7.94311 10.9809 8.05892 10.98 8.13006 10.9065L12.4199 6.43088C12.4911 6.35652 12.6069 6.35652 12.6789 6.43003L13.4242 7.20018C13.4953 7.27369 13.4953 7.39251 13.425 7.46602L8.75129 12.3391L8.75212 12.34L8.13585 12.9802C8.06471 13.0537 7.9489 13.0537 7.87776 12.9802Z",
    fill: "#0566EC",
    stroke: "#0566EC",
    strokeWidth: 0.705882,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_5013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5882,
    height: 10.9412,
    fill: "white",
    transform: "translate(3.88235 4.23438)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d8250b14da78de32ae4fe0ae7e2647a7.svg";
export { ForwardRef as ReactComponent };